"use client";

import { useEffect } from "react";

export default function useDuplicateTabDetection(onDuplicate?: () => void) {
  useEffect(() => {
    const tabId = (globalThis.crypto && 'randomUUID' in globalThis.crypto)
      ? (globalThis.crypto as Crypto).randomUUID()
      : `${Date.now()}-${Math.random()}`;

    const channel = new BroadcastChannel('tab-check');

    const handleMessage = (ev: MessageEvent) => {
      const data = ev.data || {};
      if (!data.tabId || data.tabId === tabId) return;
      if (onDuplicate) onDuplicate();
      else console.warn('Duplicate tab detected', data.tabId);
    };

    channel.addEventListener('message', handleMessage);

    // Announce ourselves so other tabs can detect us
    channel.postMessage({ type: 'HELLO', tabId });

    const handleBeforeUnload = () => channel.postMessage({ type: 'BYE', tabId });
    window.addEventListener('beforeunload', handleBeforeUnload);

    return () => {
      channel.removeEventListener('message', handleMessage);
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [onDuplicate]);
}
